<template>
  <div>
    <el-dialog title="物流信息" :visible.sync="formVisible" width="800px" v-if="formVisible">
      <el-table :data="list">
        <el-table-column label="包裹" align="center" type="index">
          <template slot-scope="scope">
            {{ scope.$index+1 }}
          </template>
        </el-table-column>
        <el-table-column label="快递公司" prop="deliveryName" align="center" />
        <el-table-column label="快递编号" prop="deliveryNum" align="center" />
        <el-table-column label="发货时间" prop="createdTime" align="center" />
        <el-table-column label="操作" align="center" width="230" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="lookLogistics(row)">查看物流</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <logistics-details-vue ref="logisticsDetailsVue" />
  </div>
</template>
<script>
import logisticsDetailsVue from '@/views/common/logisticsDetails.vue';
export default {
  components: { logisticsDetailsVue },
  data() {
    return {
      formVisible: false,
      list: [],
    }
  },
  created() {

  },
  methods: {
    handleLogistics(row) {
      console.log(row)
      this.list = row
      this.formVisible = true
    },
    lookLogistics(row) {
      let { pho } = row;
      let str = pho ? `:${pho.trim().slice(-4)}` : ''
      this.$refs.logisticsDetailsVue.handleShow(row.deliveryNum + str)
    },
  }
}
</script>
<style lang="scss" scoped>
</style>